import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import InputMask from 'react-input-mask';
import AlertMessage from '../../components/Alert';
import api from '../../services/api';
import './style.css';
import { Options, Select } from '../../components/Select';
import errorIcon from '../../img/icon/Error.svg';
import { useParams } from 'react-router-dom';

export function RepresentanteDeVendasEditar() {
    const { idRepresentante } = useParams();
    const [isLoading, setIsLoading] = useState(true);

    {/* Informações Gerais */ }
    const [nome, setNome] = useState("");
    const [numeroDocumento, setNumeroDocumento] = useState("");
    const [email, setEmail] = useState("");
    const [celular, setCelular] = useState("");
    const [chavePix, setChavePix] = useState('');

    const [error, setError] = useState("");

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const inputRef = useRef(null);

    useEffect(() => {
        const buscarDadosRepresentante = async () => {
            if (idRepresentante) {
                try {
                    const response = await api.get(`/representantes/${idRepresentante}`);
                    const representante = response.data;

                    setNome(representante[0].nome);
                    setNumeroDocumento(representante[0].documento);
                    setChavePix(representante[0].chave_pix);
                    setEmail(representante[0].email);
                    setCelular(representante[0].celular);
                } catch (error) {
                    console.error('Erro ao buscar dados da empresa', error);
                }

            }
        };

        buscarDadosRepresentante();
    }, [idRepresentante]);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    });

    const validateForm = () => {
        // if (!email.includes('@')) {
        //     setError("Por favor, insira um e-mail válido.");
        //     return false;
        // }
        if (!nome) {
            setError("Por favor, insira um nome.")
            return false;
        }
        if (!numeroDocumento) {
            setError("Por favor, selecione o número do documento.")
            return false;
        }
        // if (!celular) {
        //     setError("Por favor, insira um celular.")
        //     return false
        // }
        setError("");
        return true;
    }

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        if (!validateForm()) return;

        try {
            const userData = {
                nome: nome,
                documento: numeroDocumento,
                // email: email,
                // celular: celular,
                chave_pix: chavePix,
            }
            const response = await api.post(`editar-representante/${idRepresentante}`, userData);

            if (response.status === 200) {
                setAlert({ message: 'Responsável cadastrado', variant: 'success', show: true });
            }

        } catch (error) {
            setError("Erro ao enviar os dados. Tente novamente mais tarde.");
            console.error('Erro no registro:', error);
        }
    };


    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Form onSubmit={handleSubmit}>
                    <h3>Editar Representante</h3>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Representante' htmlFor="nome" />
                                <input
                                    type="text"
                                    id="nome"
                                    placeholder="Digite o Nome do Representante"
                                    value={nome}
                                    onChange={(e) => {
                                        setNome(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        {/* <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Tipo de documento' htmlFor="tipo_documento" />
                                <Select id="selectDocumento" onSelect={handleSelectTipoDocumento}>
                                    <Options key='CRM' value='CRM' name='CRM' />
                                    <Options key='OUTRO' value='OUTRO' name='OUTRO' />
                                </Select>
                            </FormGroup>
                        </Col> */}
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Número do Documento' htmlFor="numero_documento" />
                                <InputMask
                                    ref={inputRef}
                                    value={numeroDocumento}
                                    onChange={(e: any) => setNumeroDocumento(e.target.value)}
                                    placeholder="Digite o Número do Documento"
                                    className="form-control"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={3} xl={4}>
                            <FormGroup>
                                <Label title='Chave PIX' htmlFor="chave_pix" />
                                <InputMask
                                    ref={inputRef}
                                    id='chave_pix'
                                    value={chavePix}
                                    onChange={(e: any) => setChavePix(e.target.value)}
                                    placeholder="Digite a Chave PIX"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={4}>
                            <FormGroup>
                                <Label title='Email' htmlFor="email" />
                                <InputMask
                                    ref={inputRef}
                                    id='email'
                                    value={email}
                                    onChange={(e: any) => setEmail(e.target.value)}
                                    placeholder="Digite o Email"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        {/* <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Telefone' htmlFor="telefone" />
                                <InputMask
                                    ref={inputRef}
                                    mask="(99) 99999-9999"
                                    value={telefone}
                                    onChange={(e: any) => setTelefone(e.target.value)}
                                    placeholder="(__) _____-____"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col> */}
                        <Col xs={12} md={3} xl={6}>
                            <FormGroup>
                                <Label title='Celular' htmlFor="celular" />
                                <InputMask
                                    ref={inputRef}
                                    mask="(99) 99999-9999"
                                    value={celular}
                                    onChange={(e: any) => setCelular(e.target.value)}
                                    placeholder="(__) _____-____"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Button className="btn-main mt-4" type="submit" onClick={handleSubmit}>Salvar</Button>
                </Form>
            </Main>
            {error && (
                <div className="error-container my-3 text-danger">
                    <img
                        className="error-icon"
                        src={errorIcon}
                        alt="Error" />
                    <p className="error-text text-center mb-3">{error}</p>
                </div>
            )}
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
}
